/*
 * Resolves API URLs against VITE_API_BASE_URL when set (production builds),
 * otherwise leaves them relative so the Vite dev-server proxy in vite.config.ts
 * can route them. Pass any leading-slash path; trailing-slash bases are stripped.
 */

const RAW_BASE = import.meta.env.VITE_API_BASE_URL ?? '';
const BASE = RAW_BASE.replace(/\/+$/, '');

export function apiUrl(path: string): string {
  if (!BASE) return path;
  return `${BASE}${path.startsWith('/') ? path : `/${path}`}`;
}

/**
 * Fetch wrapper for our API. Always sends `Accept: application/json` so the
 * Laravel `Authenticate` middleware returns a 401 JSON body for unauthenticated
 * requests instead of a 302 to /login (which would have no CORS headers and
 * blow up cross-origin from new.merjem.tv). Always sends credentials so the
 * Sanctum session cookie travels with the request.
 *
 * Pass an absolute path (`/api/...`) — the helper applies apiUrl() for you.
 */
export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  if (!headers.has('Accept')) headers.set('Accept', 'application/json');
  return fetch(apiUrl(path), { ...init, credentials: 'include', headers });
}
